import { $ } from './../helpers/query';
import { scrollTo } from './../helpers/scroll-to';

export default class {
  constructor() {
    this.header = $('#header');
    this.burger = this.header.find('.header__burger');
    this.links = $('.header__link, .menu__link');
    this.menuModal = $('.menu__modal');
    this.menuLinks = $('.menu__link');
    this.pageName = document.body.getAttribute('data-page-name');
    this.currentScroll = Math.max(window.pageYOffset, 0);
  }

  init() {
    this.setWhiteHeader();
    this.scrollLinks();
    this.toggleScrolledStates();
    window.addEventListener('scroll', () => {
      this.toggleScrolledStates();
      this.currentScroll = Math.max(window.pageYOffset, 0);
    });
    this.toggleLinkActiveState();
    this.toggleMobileMenu();
    window.addEventListener('resize', () => {
      if (document.documentElement.clientWidth >= 1024) {
        this.closeMobileMenu();
      }
    });
    this.menuLinks.on('click', () => {
      this.closeMobileMenu();
    });
  }

  setWhiteHeader() {
    if (this.pageName == 'errorPage') {
      this.header.addClass('header--light');
    }
  }

  scrollLinks() {
    if (this.pageName == 'homePage') {
      scrollTo({
        selector: '.header__link, .menu__link',
        offset: 120,
        idAttr: 'data-scroll-to'
      })
    }
  }

  setScrolledState() {
    this.header.addClass('header--scrolled');
  }

  removeScrolledState() {
    this.header.removeClass('header--scrolled');
  }

  setScrolledDownState() {
    this.header.addClass('header--scrolled-down');
  }

  removeScrolledDownState() {
    this.header.removeClass('header--scrolled-down');
  }

  toggleScrolledStates() {
    if (window.pageYOffset > 0) {
      this.setScrolledState();
    } else {
      this.removeScrolledState();
    }
    if (Math.max(window.pageYOffset, 0) > this.currentScroll) {
      this.setScrolledDownState();
    } else {
      this.removeScrolledDownState();
    }
  }

  toggleLinkActiveState() {
    const self = this;
    toggleState();
    window.addEventListener('scroll', () => {
      toggleState();
    });

    function toggleState() {
      self.links.each(link => {
        const id = link.getAttribute('data-scroll-to');
        const section = $(id);
        if (section.elems.lenght) {
          const top = section.coords().top;
          const bottom = section.coords().bottom;
          const topPoint = document.documentElement.clientHeight / 3;
          const bottomPoint = document.documentElement.clientHeight / 2;

          if (top <= topPoint && bottom >= bottomPoint) {
            link.classList.add('active');
          } else if (top > topPoint || bottom < bottomPoint) {
            link.classList.remove('active');
          }
        }
      });
    }
  }

  toggleMobileMenu() {
    this.burger.on('click', () => {
      this.header.toggleClass('header--opened-menu');
      this.menuModal.toggleClass('menu__modal--opened');
      document.body.classList.toggle('no-overflow');
    })
  }

  openMobileMenu() {
    this.header.addClass('header--opened-menu');
    this.menuModal.addClass('menu__modal--opened');
    document.body.classList.add('no-overflow');
  }

  closeMobileMenu() {
    this.header.removeClass('header--opened-menu');
    this.menuModal.removeClass('menu__modal--opened');
    document.body.classList.remove('no-overflow');
  }

}
